exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".zIndex--2Flfr {\n\tcursor: default;\n\tcolor: #ddd;\n\tpadding: 0 16px;\n\tmargin-right: -4px;\n\tline-height: 2;\n\ttext-align: center;\n}", ""]);

// Exports
exports.locals = {
	"zIndex": "zIndex--2Flfr"
};